import api from '../../api';
import { fetchAllPages } from './api/fetchAllPages';

export default api;
export { fetchAllPages };

export function getRevenueMap(propertyId) {
  return api.get('/reports/revenue-categories/revenue-map/', {
    params: { assigned_property: propertyId },
  });
}

export function updateRevenueGroup(groupId, data) {
  return api.patch(`/reports/revenue-groups/${groupId}/`, data);
}

export function updateDepartment(departmentId, data) {
  return api.patch(`/reports/departments/${departmentId}/`, data);
}

export function getRoomRevenueKpiBasis(propertyId) {
  return fetchAllPages('/reports/room-revenue-kpi-basis/', {
    params: {
      assigned_property: propertyId,
      ordering: 'revenue_bucket__display_order,revenue_bucket__name',
    },
  });
}

export function getRevenueBuckets() {
  return fetchAllPages('/reports/revenue-buckets/', {
    params: { ordering: 'display_order,name' },
  });
}

export function createRoomRevenueKpiBasis(data) {
  return api.post('/reports/room-revenue-kpi-basis/', data);
}

export function updateRoomRevenueKpiBasis(basisId, data) {
  return api.patch(`/reports/room-revenue-kpi-basis/${basisId}/`, data);
}

export function deleteRoomRevenueKpiBasis(basisId) {
  return api.delete(`/reports/room-revenue-kpi-basis/${basisId}/`);
}